import { KeyboardArrowDown } from '@mui/icons-material';
import { generateKey } from '@on3/ui-lib/utils/generateKey';
import clsx from 'clsx';
import { useState } from 'react';

import styles from './Collapsible.module.scss';

interface ICollapsibleProps {
  children: JSX.Element;
  expanded?: boolean;
  toggleContent?: string | JSX.Element;
  className?: string;
}

export const Collapsible = ({
  children,
  expanded = false,
  toggleContent = 'Toggle',
  className,
}: ICollapsibleProps) => {
  const key = generateKey();

  const [isExpanded, setIsExpanded] = useState<boolean>(expanded);

  return (
    <div
      className={clsx(styles.block, className)}
      data-expanded={isExpanded}
      data-ui="collapsable"
    >
      <button
        aria-controls={`panel-${key}`}
        aria-expanded={isExpanded}
        className={styles.toggle}
        data-ui="collapsible-toggle"
        onClick={() => setIsExpanded((prev) => !prev)}
        type="button"
      >
        {toggleContent}
        <KeyboardArrowDown className={styles.arrow} />
      </button>
      <div
        className={clsx(styles.panel, {
          [styles.expanded]: isExpanded,
        })}
        data-ui="collapsible-panel"
        id={`panel-${key}`}
      >
        {children}
      </div>
    </div>
  );
};
